import script from "./FilterController.vue?vue&type=script&setup=true&lang=js"
export * from "./FilterController.vue?vue&type=script&setup=true&lang=js"

import "./FilterController.vue?vue&type=style&index=0&id=4dd4029d&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4dd4029d"]])

export default __exports__